import React from "react";
import type MastResultDto from "../../../../dto/calculations/MastResultDto";

import styles from "../sidePanel/constructionCalculationsPanel.module.scss";
import { useTranslation } from "react-i18next";
import { Stack } from "@fluentui/react";
import { renderHeaders, renderResults } from "./CalculationMastResultsNewHelpers";

const CalculationMastResultsNew: React.FunctionComponent<{
    mastResults: MastResultDto;
}> = ({mastResults}) => {
    const {t} = useTranslation(["constructionCalculations"]);
    const mastResultsAreAvailable = (mastResults?.loadCaseResults?.length ??  0) > 0;

    return (
        <Stack grow={5} className={`${styles.results}`}>
          {mastResultsAreAvailable && (
            <div className={styles.mastBtn}>
              <table className={styles.resultTable}>
                <thead>
                  <tr className={styles.headerCategories}>
                    <th key="empty-0" className={styles.emptyHeader} />
                    <th key="[kN]" colSpan={3}>
                      [kN]
                    </th>
                    <th key="[kNm]" colSpan={3}>
                      [kNm]
                    </th>
                    <th key="[MPa]" colSpan={2}>
                      [MPa]
                    </th>
                    <th key="[mm]" colSpan={2}>
                      [mm]
                    </th>
                    <th key="[rad]" colSpan={1}>
                      [rad]
                    </th>
                    <th key="empty-1" colSpan={5} />
                  </tr>
    
                  <tr className={styles.headers}>
                    {renderHeaders(mastResults.loadCaseResults, t)}
                  </tr>
    
                  <tr className={styles.emptyRow}>
                    <td />
                  </tr>
                </thead>
                <tbody>{renderResults(mastResults.loadCaseResults, t)}</tbody>
              </table>
            </div>
          )}
        </Stack>
      );
};

export default CalculationMastResultsNew;